import React from "react";
import { motion } from "framer-motion";

const FeaturesGrid = ({
  features,
  cols = 4, // default grid
  textColor = "text-gray-900",
  descColor = "text-gray-600",
  iconColor = "text-green-600",
  dividerFrom = "after:from-green-500",
  dividerTo = "after:to-orange-500",
}) => {
  // ✅ predefine grid classes (Tailwind needs static class names)
  const gridCols = {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
  };

  return (
    <div className={`grid md:grid-cols-2 ${gridCols[cols] || "lg:grid-cols-4"} gap-5`}>
      {features.map((f, i) => {
        // ✅ divider logic
        const isLast = i === features.length - 1;
        const isSingleCol = cols === 1;

        const dividerClass = !isLast
          ? `after:content-[''] after:absolute after:bg-gradient-to-r lg:after:bg-gradient-to-t ${dividerFrom} ${dividerTo}
              ${isSingleCol
                ? // 👉 single column = only bottom divider
                  "after:w-[100%] after:h-[2px] after:bottom-0"
                : // 👉 multi column = bottom on mobile, vertical on desktop
                  "after:w-[100%] after:h-[2px] after:bottom-0 md:after:w-[2px] md:after:h-[70%] md:after:top-6 md:after:right-0 md:after:bottom-auto"}
            `
          : "";

        return (
          <motion.div
            key={i}
            className={`py-6 relative ${dividerClass}`}
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
          >
            {/* ✅ ICON */}
            <div className={`mb-4 ${iconColor}`}>{f.icon}</div>

            {/* ✅ TITLE */}
            <h3 className={`font-semibold text-xl mb-2 ${textColor}`}>
              {f.title}
            </h3>

            {/* ✅ DESC */}
            <p className={`text-sm ${descColor}`}>{f.desc}</p>
          </motion.div>
        );
      })}
    </div>
  );
};

export default FeaturesGrid;
